import { render, staticRenderFns } from "./ProjectImage.vue?vue&type=template&id=3772cba4&lang=pug&"
import script from "./ProjectImage.vue?vue&type=script&lang=js&"
export * from "./ProjectImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports